import React, { SFC } from 'react';
import { ITimeoutWarning } from '../../../services/rtc/constants';
import CallErrorMessage from './CallErrorMessage';
import { PickProps } from '../../../utils/types';
import Countdown from '../../utilities/Countdown';

interface IProps extends
PickProps<typeof CallErrorMessage, 'buttonAction' | 'buttonLabel' | 'severity'>,
PickProps<typeof Countdown, 'children'> {
  readonly timeoutWarning: ITimeoutWarning;
}

/**
 * Shows a message with a countdown until the next automatic
 * reconnect + a button to do it immediately.
 */
const CountdownMessage: SFC<IProps> = ({ children, timeoutWarning: { triggeredAt, timeToReconnect }, ...props }) =>
  <CallErrorMessage {...props}>
    <Countdown resetKey={timeToReconnect + triggeredAt} milliseconds={timeToReconnect}>
      {children}
    </Countdown>
  </CallErrorMessage>;

export default CountdownMessage;
